import React from 'react';
import { FaPlane, FaHotel, FaBuilding, FaClock, FaEye, FaPencilAlt } from 'react-icons/fa';

// Helper function to format date strings into a "time ago" format
const formatTimeAgo = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    let interval = seconds / 31536000;
    if (interval > 1) return Math.floor(interval) + " years ago";
    interval = seconds / 2592000;
    if (interval > 1) return Math.floor(interval) + " months ago";
    interval = seconds / 86400;
    if (interval > 1) return Math.floor(interval) + " days ago";
    interval = seconds / 3600;
    if (interval > 1) return Math.floor(interval) + " hours ago";
    interval = seconds / 60;
    if (interval > 1) return Math.floor(interval) + " minutes ago";
    return "Just now";
};

const BookingItem = ({ booking }) => {
    const isFlight = booking.bookingType === 'Flight';
    const icon = isFlight ? <FaPlane /> : <FaHotel />;
    const iconClass = isFlight ? 'flight' : 'hotel';

    return (
        <div className="booking-item-new">
            {/* Column 1: Icon */}
            <div className={`booking-icon-new ${iconClass}`}>
                {icon}
            </div>

            {/* Column 2: Booking Information */}
            <div className="booking-info-new">
                <div className="title-status">
                    <h4>{booking.title}</h4>
                    <span className={`status-badge ${booking.status.toLowerCase()}`}>
                        {booking.status}
                    </span>
                </div>
                <p className="details">{booking.subtitle}</p>
                <p className="meta">
                    <FaClock /> {formatTimeAgo(booking.bookingDate)}
                    <span style={{ margin: '0 0.5rem' }}>•</span>
                    <FaBuilding /> {booking.branchName}
                </p>
            </div>

            {/* Column 3: Actions and Price */}
            {/* <div className="booking-actions-new">
                <span className="price">INR{booking.price.toLocaleString('en-IN')}</span>
                <button className="btn-action view" aria-label="View Booking">
                    <FaEye />
                </button>
                <button className="btn-action edit" aria-label="Edit Booking">
                    <FaPencilAlt />
                </button>
            </div> */}
        </div>
    );
};

export default BookingItem;